exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box-card[data-v-db700a32]{margin-bottom:30px}.disabled[data-v-db700a32]{opacity:.6}form[data-v-db700a32]{margin:15px 0 100px}form input[type=email][data-v-db700a32],form input[type=text][data-v-db700a32]{display:block;height:40px;line-height:1em;padding:0 12px;margin-bottom:14px;font-size:1em;color:#5c6b80;border-radius:3px;vertical-align:middle;box-shadow:none;border:0;width:100%;max-width:700px;font-family:Lato,Helvetica Neue,Helvetica,Arial,sans-serif;background-color:#eaedf2;transition:background-color .24s ease-in-out}form .zeckit-btn[data-v-db700a32]{color:#fff!important;padding:15px 30px;border:0;box-shadow:0 4px 8px 0 rgba(50,50,50,.75);text-decoration:none;display:table;background-color:#002663}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db700a32","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Office.vue
// module id = 417
// module chunks = 0